const JobData = [{
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "0-2",
                category: "Big Brands",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"
        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [
                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately",
            

        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately",
            
        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,



                CTC: "2000-3000",
                StartDate: "Immediately"


        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Mumbai",
                Experience: "6-2 Year",
                category: "Big Brands",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        // work From home
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Pune",
                Experience: "6-2 Year",
                category: "Work From Home",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Pune",
                Experience: "6-2 Year",
                category: "Work From Home",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Pune",
                Experience: "6-2 Year",
                category: "Work From Home",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Pune",
                Experience: "6-2 Year",
                category: "Work From Home",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Pune",
                Experience: "6-2 Year",
                category: "Work From Home",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        // Part-time
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Banaras",
                Experience: "6-2 Year",
                category: "Part-time",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Banaras",
                Experience: "6-2 Year",
                category: "Part-time",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Banaras",
                Experience: "6-2 Year",
                category: "Part-time",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Banaras",
                Experience: "6-2 Year",
                category: "Part-time",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Banaras",
                Experience: "6-2 Year",
                category: "Part-time",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"


        },

        // MBA
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,kashmir",
                Experience: "6-2 Year",
                category: "MBA",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,kashmir",
                Experience: "6-2 Year",
                category: "MBA",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,kashmir",
                Experience: "6-2 Year",
                category: "MBA",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,kashmir",
                Experience: "6-2 Year",
                category: "MBA",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,kashmir",
                Experience: "6-2 Year",
                category: "MBA",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },

        // Engineering
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Gujarat",
                Experience: "6-2 Year",
                category: "Engineering",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Gujarat",
                Experience: "6-2 Year",
                category: "Engineering",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Gujarat",
                Experience: "6-2 Year",
                category: "Engineering",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Gujarat",
                Experience: "6-2 Year",
                category: "Engineering",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Gujarat",
                Experience: "6-2 Year",
                category: "Engineering",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,
                CTC: "2000-3000",
                StartDate: "Immediately"


        },

        // Media
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaypur",
                Experience: "6-2 Year",
                category: "media",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"

        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaypur",
                Experience: "6-2 Year",
                category: "media",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"

        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaypur",
                Experience: "6-2 Year",
                category: "media",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"

        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaypur",
                Experience: "6-2 Year",
                category: "media",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"

        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaypur",
                Experience: "6-2 Year",
                category: "media",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"

        },
        // Design

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Lucknow",
                Experience: "6-2 Year",
                category: "Design",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Lucknow",
                Experience: "6-2 Year",
                category: "Design",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Lucknow",
                Experience: "6-2 Year",
                category: "Design",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Lucknow",
                Experience: "6-2 Year",
                category: "Design",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Lucknow",
                Experience: "6-2 Year",
                category: "Design",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },
        // Data Science

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaunpur",
                Experience: "6-2 Year",
                category: "Data Science",
                aboutCompany: `Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube 

2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaunpur",
                Experience: "6-2 Year",
                category: "Data Science",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaunpur",
                Experience: "6-2 Year",
                category: "Data Science",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaunpur",
                Experience: "6-2 Year",
                category: "Data Science",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },

        {
                title: "Job Title",
                company: "ankitOrg Ltd.",
                location: "India,Jaunpur",
                Experience: "6-2 Year",
                category: "Data Science",
                aboutCompany: `"Instagram page 
We are India's 1st online luxury content platform where we showcase everything luxurious and unique on various platforms like YouTube, Instagram, etc. We do marketing and professional shoots for various industries like real estate, travel, food, lifestyle, bikes, cars, fashion, events & much more.",`,
                aboutJob: `Selected intern's day-to-day responsibilities include:

1. Create engaging and visually stunning content for our social media platforms, including Instagram, TikTok, and YouTube
2. Collaborate with our marketing team to develop innovative and unique content ideas that align with our brand identity
3. Stay up-to-date with the latest trends and styles in urban fashion and incorporate them into your content
4. Engage with our followers and respond to their comments and messages in a timely and professional manner
5. Assist in organizing and attending photoshoots and video shoots to capture behind-the-scenes content
6. Collaborate with influencers and other content creators to expand our reach and increase brand awareness
7. Analyze and report on the performance of your content, tracking metrics such as engagement, reach, and conversion rates

If you're passionate about creating jaw-dropping content, have a keen eye for fashion, and want to be part of a dynamic team in the urban fashion industry, then this Job is perfect for you! Join Urban NXT and make your mark as a Content Creator (Influencer) intern. Apply now and let your creativity shine!
Earn certifications in these skills
Learn Business Communication`,
                Whocanapply: `Only those candidates can apply who:

1. are available for full time (in-office) Job

2. can start the Job between 29th Dec'23 and 2nd Feb'24

3. are available for duration of 3 months

4. are from or open to relocate to Mumbai and neighboring cities

5. have relevant skills and interests

* Women wanting to start/restart their career can also apply.`,
                perks: [

                        "Flexible work hours",
                        "Informal dress code",
                        "Free snacks & beverages",

                ],

                numberOfopning: "3",
                            AdditionalInfo: `Job offer: On successful conversion to a permanent employee, the candidate can expect a salary of Rs. 100000 to 300000 /year

Stipend structure: This is a performance-based internship. In addition to the minimum-assured stipend, you will also be paid a performance-linked incentive (10% of revenue generated).`,

                CTC: "2000-3000",
                StartDate: "Immediately"
        },



];

module.exports = JobData